/**
 * reducers/app.ts
 * desc: global app reducer
 * note: holds globl app state
 *
 */

import type { Reducer } from '@reduxjs/toolkit';
import type { AppAction } from '../actions/app';

export interface AppState {
    hasUnsavedChanges: boolean;
}

const INITIAL_STATE: AppState = {
    hasUnsavedChanges: false,
};


function appReducer(state: AppState = INITIAL_STATE, action: AppAction): AppState {
    switch (action.type) {

        case 'SET_HAS_UNSAVED_CHANGES':
            return _setHasUnsavedChanges(state, action.payload);

        default:
            return state;
    }
}

function _setHasUnsavedChanges(state: AppState, payload: boolean): AppState {
    return {
        ...state,
        hasUnsavedChanges: payload,
    };
}

export default appReducer as Reducer<AppState>;
